/**
 * Freesound Audio Asset
 */

import { BaseFreesoundAsset } from './base';
import type { FreesoundSound } from '../types';

export class AudioAsset extends BaseFreesoundAsset {
  constructor(sound: FreesoundSound, apiKey: string, baseUrl: string) {
    super(sound, apiKey, baseUrl);
  }

  /**
   * Get visualization image URLs
   */
  getVisualizationUrls(): {
    waveformLarge: string;
    waveformMedium: string;
    spectralLarge: string;
    spectralMedium: string;
  } {
    return {
      waveformLarge: this.sound.images.waveform_l,
      waveformMedium: this.sound.images.waveform_m,
      spectralLarge: this.sound.images.spectral_l,
      spectralMedium: this.sound.images.spectral_m,
    };
  }

  /**
   * Get audio file properties
   */
  getAudioProperties(): {
    duration: number;
    samplerate: number;
    channels: number;
    bitrate: number;
    fileType: string;
  } {
    return {
      duration: this.sound.duration,
      samplerate: this.sound.samplerate,
      channels: this.sound.channels,
      bitrate: this.sound.bitrate,
      fileType: this.sound.type,
    };
  }
}
